import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'

export function OutWarehouseDetailsList() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}
